import React from 'react';

import { reverse } from 'named-urls';

import Record from 'ui/Record/Record';

import MainHeader from 'components/MainHeader';
import { PrimaryButton } from 'components/Button';

import routes from 'core/routes';

import { useNavBarHeight } from 'utils/hooks/navbar';
import { useStore } from 'utils/hooks/store';

import { NEW_TEMPLATE_ID } from 'stores/AuditFormBuilder/AuditFormBuilder';
import { RISK_ASSESSMENT_BUILDER_MODE } from 'stores/AuditFormBuilder/mode';

import RiskAssessmentTemplatesTable from './components/RiskAssessmentTemplatesTable';

const RiskAssessmentTemplates: React.FunctionComponent = (): React.ReactElement => {
  const navBarHeight = useNavBarHeight();
  const { routing } = useStore();

  return (
    <Record
      Header={
        <MainHeader
          title="Risk Assessment Templates"
          breadcrumbs={RISK_ASSESSMENT_BUILDER_MODE.breadcrumbs}
          action={
            <PrimaryButton
              onClick={() =>
                routing.push(reverse(routes.dashboard.risks.templates.details, { templateId: NEW_TEMPLATE_ID }))
              }
              data-testid="risk-templates-new"
            >
              New template
            </PrimaryButton>
          }
        />
      }
      Content={(onError) => <RiskAssessmentTemplatesTable onError={onError} />}
      navBarHeight={navBarHeight}
    />
  );
};

export default RiskAssessmentTemplates;
